// TODO: Merge this with config/constants/urls.js
import { useContext } from 'react'
import { InitiativeHierarchyContext } from 'src/libraries/contexts/InitiativeHierarchy'

// Organization Settings
export const settingsUrl = '/settings'
export const settingsContentInitiativeTypeUrl = initiativeTypeId => (
   `${settingsUrl}/content/initiativeType/${initiativeTypeId}`
)
export const settingsDesignUrl = '/settings/design'
export const settingsSiteCommerceUrl = '/settings/site/commerce'

// Initiative
export const initiativeUrl = () => {
   const { initiative } = useContext(InitiativeHierarchyContext)
   return initiative
      ? `/initiatives/${initiative.slug}`
      : undefined
}

// Initiative Settings
export const initiativeSettingsUrl = () => {
   const { initiative } = useContext(InitiativeHierarchyContext)
   return initiative
      ? `/initiatives/${initiative.slug}/settings`
      : undefined
}

export const initiativeSettingsPeopleRoleUrl = (roleId) => {
   const baseUrl = initiativeSettingsUrl()
   return baseUrl
      ? `${baseUrl}/people/role/${roleId}`
      : undefined
}

export const initiativeSettingsReportsUrl = () => {
   const baseUrl = initiativeSettingsUrl()
   return baseUrl
      ? `${baseUrl}/reports`
      : undefined
}
